import React from "react";
import { Input } from "reactstrap";

// Single source of truth for "should the label float". Every field in this
// screen uses this same rule now - no more per-field variations.
export const isFilled = (value) =>
  value !== undefined && value !== null && String(value).trim() !== "";

/**
 * Shared field shell: input + floating label, styled identically for every
 * field on the Profile screen (border, radius, shadow, readonly bg all come
 * from the .pf-input / .pf-input-disabled classes in Profile.css).
 *
 * `alwaysFloat` is for fields like Date of Birth / Joining Date, where the
 * label should sit above the field regardless of value (dates read oddly
 * as placeholder-style text).
 */
function FormField({
  id,
  label,
  name,
  value,
  type = "text",
  disabled = false,
  alwaysFloat = false,
  onChange,
  displayValue,
  ...rest
}) {
  const floated = alwaysFloat || isFilled(value);

  return (
    <div className="pf-field">
      <Input
        id={id}
        name={name}
        type={type}
        value={displayValue !== undefined ? displayValue : (value ?? "")}
        disabled={disabled}
        onChange={onChange}
        className={`pf-input ${disabled ? "pf-input-disabled" : ""}`}
        {...rest}
      />
      <label htmlFor={id} className={`pf-label ${floated ? "pf-label-float" : ""}`}>
        {label}
      </label>
    </div>
  );
}

export default FormField;